export const items = [
  {
    title: "1",
    cardTitle: "Invitation",
    cardDetailedText:
      "Interested recruiters mail us the JD at tnp@mmmut.ac.in (including CTC, Job Role, Eligible Streams and other relevant details)",
  },
  {
    title: "2",
    cardTitle: "Job Profile Posting",
    cardDetailedText:
      "We share it among the eligible and interested candidates through Superset Platform/Notice & GForm.",
  },
  {
    title: "3",
    cardTitle: "Sharing Interested Candidates List",
    cardDetailedText:
      " Within a few working days, we share the excel containing list of interested & eligible candidates to the recruiter.",
  },
  {
    title: "4",
    cardTitle: "Planning & Process of Drive",
    cardDetailedText:
      "Recruiter can inform about the dates required for process to us and we coordinate accordingly till the successful completion.",
  },

  {
    title: "5",
    cardTitle: "Result Declaration",
    cardDetailedText:
      "The company rolls out the offer letter either to T&P or to the candidates, and we coordinate accordingly.",
  },
];
